import { Component } from '@angular/core';

@Component({
  selector: 'rs-success',
  templateUrl: 'success.component.html',
  styleUrls: ['success.component.scss']
})
export class SuccessComponent {}
